import Loading from "components/loading";

export default function LoadingProcedure(message) {
    return (
        <div className="loading-procedure__container">
            <Loading />
            <p>{message && message.message ? message.message : 'Recuperando el trámite...'}</p>
        </div>

    )
}